import React from "react";
import {
  webDevelopImg,
  Responsive,
  DevelopmentProcess,
  Design,
  planning1,
  planning2,
  planning3,
  planning4,
  planning5,
} from "../../Assets.tsx";
import { ServiceShell, Section, Hero, Intro, Split, Cta } from "../Common-component/ServiceKit";

const services = [
  {
    img: Design,
    alt: "Designing",
    chip: "Design",
    title: "Custom Website Design And Development",
    text: "Our expertise lies in custom website design, where we create websites that perfectly align with our client’s distinct requirements and brand identity. Together, our designers and developers build a website that is both aesthetically pleasing and easy to use and effectively conveys the client’s message to its intended audience, which is why we are the best Website development company in Pune.",
  },
  {
    img: DevelopmentProcess,
    alt: "Development",
    chip: "E-Commerce",
    title: "E-Commerce Website Development",
    text: "Our website development services encompass vast experience in designing e-commerce websites that are user friendly, secure, and focused on generating conversions. We aim to provide clients with a flawless online shopping experience through the use of cutting edge technology in website development for our e-commerce solutions.",
  },
  {
    img: Responsive,
    alt: "Responsive",
    chip: "Responsive",
    title: "Responsive Web Design",
    text: "With the increasing use of mobile devices for internet access, businesses need to invest in responsive website development services that cater to all screen sizes. We provide top notch website development services through our responsive web design to ensure that our client’s website appears and functions beautifully on all devices, from desktops to mobiles.",
  },
];

const process = [
  {
    img: planning1,
    alt: "Planning",
    title: "Planning",
    text: "During this first stage, as a provider of web development services, we gather data regarding the client’s industry, intended audience, and website goals. To find areas for improvement and potential prospects for expansion, we also thoroughly analyze any current websites the client may have.",
  },
  {
    img: planning2,
    alt: "Design",
    title: "Design",
    text: "During this stage, our web designers develop a website design that is both aesthetically pleasing and user friendly and effectively conveys the client’s message to their intended audience. When designing, we consider the client’s target audience and brand identity.",
  },
  {
    img: planning3,
    alt: "Development",
    title: "Development",
    text: "After the design is complete, a functional website is created by our team of talented web developers. Website development involved using various technologies and tools, including HTML, CSS, JavaScript, and well known content management systems like Shopify and WordPress. These technologies enable us to design intuitive, responsive, and aesthetically pleasing websites.",
  },
  {
    img: planning4,
    alt: "Testing",
    title: "Testing",
    text: "After a website is created, it goes through a rigorous testing phase to ensure there are no bugs and that everything works as it should. As a part of our website development process, we conduct compatibility testing on various browsers and mobile platforms.",
  },
  {
    img: planning5,
    alt: "Launch",
    title: "Launch",
    text: "The website is prepared for launch once the testing process is complete. We, a web development agency in India, collaborate closely with the client to ensure a seamless transfer to the live website.",
  },
];

const WebDevelopmentPage = () => (
  <ServiceShell>
    {/* HERO */}
    <Hero
      chip="Web Development"
      title="Expert Website Development Services For Your Business"
      paragraphs={[
        "Web development services are a critical aspect of any business’s online presence. A well designed and functional website is essential for attracting and retaining customers and building brand credibility. As a website development company in India, ATUM Information Technology specializes in creating high quality websites that meet each client’s unique needs.",
        "At ATUM Information Technology, we understand the importance of having a strong online presence and are dedicated to delivering web development services that will help your business succeed.",
      ]}
      tags={["Custom Design", "E-Commerce", "Responsive", "CMS"]}
      img={webDevelopImg}
      alt="Web development"
    />

    {/* CLIENT NEEDS */}
    <Section tint>
      <Intro
        chip="Client First"
        title="Understanding The Client's Needs"
        paragraphs={[
          "At ATUM Information Technology, we understand that every client has specific needs and goals for their website, which is why we offer custom website development. As a reliable Web development company in Pune, we invest ample time to understand the business, target audience and goals of every client before starting any project.",
          "During our initial consultation meetings, as a website development agency, we discussed the client’s website vision and gained knowledge about their industry, competition, and target market. To identify potential opportunities for growth and expansion, we conduct a comprehensive analysis of the client’s existing website, if any, as part of our website development process.",
          "Once we clearly understand the client’s needs and goals, we can then recommend the most appropriate web development services to meet those needs. As the best web development company in India, our experienced team offers a broad spectrum of services, which includes:",
        ]}
      />
    </Section>

    {/* SERVICES */}
    {services.map((s, i) => (
      <Section key={s.title}>
        <Split img={s.img} alt={s.alt} reverse={i % 2 === 1} chip={s.chip} title={s.title} paragraphs={[s.text]} />
      </Section>
    ))}

    <Section style={{ paddingTop: 0 }}>
      <Intro
        paragraphs={[
          "We provide a variety of additional web development services in addition to these essential ones, including content management systems, website upkeep, and digital marketing. To guarantee that our client’s websites live up to their expectations and accomplish their business objectives, we work closely with them throughout the web creation process.",
          "We delight in providing our clients with top notch web development services enabling them to prosper online at ATUM Information Technology. We are dedicated to comprehending each client’s particular requirements and objectives and creating a website that meets those requirements. Contact us now if you want assistance from a reliable web development company in India in achieving your goals.",
        ]}
      />
    </Section>

    {/* PROCESS */}
    <Section tint style={{ paddingBottom: 30 }}>
      <Intro
        chip="How We Work"
        title="Website Development Process"
        paragraphs={[
          "ATUM Information Technology utilizes an organized and systematic approach to website building in order to deliver high quality websites that align with the needs and objectives of our clients through our exceptional web development services. Usually, the following steps are involved in the website development process:",
        ]}
      />
    </Section>
    {process.map((p, i) => (
      <Section key={p.title}>
        <Split
          img={p.img}
          alt={p.alt}
          reverse={i % 2 === 1}
          chip={"Step " + (i + 1)}
          title={p.title}
          paragraphs={[p.text]}
        />
      </Section>
    ))}

    {/* HIRE */}
    <Cta
      chip="Hire Us"
      title="Hire Our Web Developers From ATUM Information Technology"
      paragraphs={[
        "We provide web development services that involve staying in close contact with our clients throughout the creation process to ensure their website lives up to their expectations and accomplishes their business objectives.",
        "ATUM Information Technology is skilled in various technologies and tools, including programming languages and frameworks like HTML, CSS, JavaScript, and others. Our responsive, aesthetically pleasing, and user friendly websites are made using these technologies. Our programmers are also experienced with well known Content Management Systems (CMS), including Shopify and WordPress. Contact our web development company in Pune now to take the services from a reliable web development company in India for the website development for your business.",
      ]}
    />
  </ServiceShell>
);

export default WebDevelopmentPage;